import React from 'react';
import { Resizable } from 're-resizable';
import { observer } from 'mobx-react';
// @ts-ignore
import mainTheme from 'styles/themes/wikifactory';
import { frameStore } from 'apps/components/Frame/appManager';
import { FrameHeaderHeight, FrameSidebarWidth } from 'styles/constants';
import { FrameSidebarStyled } from './frameSidebar.styled';
import NavigationPanel from '../NavigationPanel';
import {
  NavTab,
  Dialog,
  Icon,
  NotificationBadge,
} from '../../../../components';
import Inbox from '../../../Inbox';
import FooterMenu from './FooterMenu';

const minInboxWidth = 250;
const maxInboxWidth = 500;

const FrameSidebar = observer(() => {
  const [anchorEl, setAnchor] = React.useState<null | HTMLElement>(null);

  const { inboxManager } = frameStore;

  const handleInboxClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!anchorEl) setAnchor(event.currentTarget);
    inboxManager.ToggleInbox();
  };

  const handleDialogClose = () => {
    inboxManager.ToggleInbox(false);
  };

  return (
    <FrameSidebarStyled>
      <NavigationPanel
        isSidebarOpen={inboxManager.isInboxOpen}
        toggleButton={
          <NavTab
            active={inboxManager.isInboxOpen}
            onClick={handleInboxClick}
            data-for='tabsTooltip'
            data-tip='Inbox'
            data-test-id='Inbox'
            data-place='right'
          >
            <NotificationBadge value={inboxManager.notificationBadgeNum}>
              <Icon name='comment' />
            </NotificationBadge>
          </NavTab>
        }
      />
      <Dialog
        onClose={handleDialogClose}
        open={inboxManager.isInboxOpen}
        placement='right-top'
        anchorEl={anchorEl}
        offsetBottom={FrameHeaderHeight}
        overlayStyle={{
          top: FrameHeaderHeight,
          left: FrameSidebarWidth,
        }}
        sx={{ overflow: 'hidden', position: 'fixed' }}
      >
        <Resizable
          minWidth={minInboxWidth}
          maxWidth={maxInboxWidth}
          enable={{ right: true }}
          defaultSize={{ width: maxInboxWidth, height: '100%' }}
          style={{ background: mainTheme.color.wfWhite }}
        >
          <Inbox onClose={handleDialogClose} />
        </Resizable>
      </Dialog>
      <FooterMenu />
    </FrameSidebarStyled>
  );
});

export default FrameSidebar;
